import React, { useEffect, useState } from 'react';
import Navbar       from '../components/common/Navbar';
import Footer       from '../components/common/Footer';
import BottomNav    from '../components/common/BottomNav';
import './CommunityPage.css';

const CHANNELS = [
  {
    key: 'whatsapp',
    name: 'WhatsApp Group',
    tag: 'Most Active',
    blurb: 'Daily horoscope, festival reminders, slot openings — straight to your phone.',
    href: 'https://chat.whatsapp.com/your-group-link',
    icon: '💬',
    cls: 'cp-channel--whatsapp',
  },
  {
    key: 'telegram',
    name: 'Telegram Channel',
    tag: 'Quiet Updates',
    blurb: 'Announcements only — no chat noise. Mute-friendly.',
    href: 'https://t.me/vtdastrology',
    icon: '✈️',
    cls: 'cp-channel--telegram',
  },
  {
    key: 'youtube',
    name: 'YouTube',
    tag: 'Free Lessons',
    blurb: 'Vedic teachings, chart explainers, monthly transit recaps.',
    href: 'https://youtube.com/@vtdastrology',
    icon: '▶',
    cls: 'cp-channel--youtube',
  },
  {
    key: 'instagram',
    name: 'Instagram',
    tag: 'Daily Reels',
    blurb: 'Bite-size astrology reels, behind-the-scenes, festival posts.',
    href: 'https://instagram.com/vtdastrology',
    icon: '📷',
    cls: 'cp-channel--instagram',
  },
];

const FALLBACK_POSTS = [
  {
    id: 'welcome',
    date: 'Today',
    title: 'Welcome to the VTD Astrology community',
    body: 'This space is where I share updates, slot openings, festival timings, and short Vedic insights. Join WhatsApp or Telegram to get notified the moment a new slot opens — they fill within hours.',
    cta: { label: 'Read My Chart', href: '/chat' },
  },
];

const CommunityPage = () => {
  const [posts, setPosts]   = useState(FALLBACK_POSTS);
  const [loading, setLoad]  = useState(true);

  useEffect(() => {
    document.body.classList.add('has-bottom-nav');
    fetch('/api/community/posts')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => { if (d && d.success && Array.isArray(d.posts) && d.posts.length) setPosts(d.posts); })
      .catch(() => {})
      .finally(() => setLoad(false));
    return () => document.body.classList.remove('has-bottom-nav');
  }, []);

  return (
    <>
      <Navbar />
      <main className="cp">
        <header className="cp__hero">
          <p className="cp__eyebrow">VTD Community</p>
          <h1 className="cp__title">Stay close to the cosmos.</h1>
          <p className="cp__sub">
            Join the channel that fits you — get daily horoscopes, slot alerts, festival
            reminders, and Tilak's short Vedic insights.
          </p>
        </header>

        <section className="cp__channels" aria-label="Join channels">
          {CHANNELS.map(c => (
            <a key={c.key} href={c.href} target="_blank" rel="noopener noreferrer"
               className={`cp-channel ${c.cls}`}>
              <div className="cp-channel__icon" aria-hidden="true">{c.icon}</div>
              <div className="cp-channel__meta">
                <span className="cp-channel__tag">{c.tag}</span>
                <h3 className="cp-channel__name">{c.name}</h3>
                <p className="cp-channel__blurb">{c.blurb}</p>
              </div>
              <span className="cp-channel__arrow" aria-hidden="true">→</span>
            </a>
          ))}
        </section>

        <section className="cp__feed" aria-label="Latest updates">
          <h2 className="cp__feed-title">Latest from Tilak</h2>
          {loading
            ? <p className="cp__loading">Loading updates…</p>
            : (
              <ul className="cp__post-list">
                {posts.map(p => (
                  <li key={p.id} className="cp-post">
                    <span className="cp-post__date">{p.date}</span>
                    <h3 className="cp-post__title">{p.title}</h3>
                    <p className="cp-post__body">{p.body}</p>
                    {p.cta && (
                      <a className="cp-post__cta" href={p.cta.href}>
                        {p.cta.label} →
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            )}
        </section>

        <section className="cp__cta">
          <p>Ready for your reading? Connect with Tilak directly.</p>
          <a href="/chat" className="cp__cta-btn">💬 Chat with Tilak Now</a>
        </section>
      </main>
      <Footer />
      <BottomNav />
    </>
  );
};

export default CommunityPage;
